import { call, put, takeLatest } from 'redux-saga/effects'

import { NOTIFICATION_TYPE } from '~/common/constants'
import addNotification from '~/utils/toast'

import {
  actSyncOrgStructureFailed,
  actSyncOrgStructureSuccess,
  MASTER_SYNC_ORG_STRUCTURE,
} from '../../actions/org-structure'
import { apiSyncOrgStructure } from '../../apis/org-structure'

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doSync(action) {
  try {
    const response = yield call(apiSyncOrgStructure, action?.payload)

    if (response?.statusCode === 200) {
      const data = {
        data: response.data?.items,
        total: response.data?.meta?.total,
      }
      yield put(actSyncOrgStructureSuccess(data))
      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess()
      }
      addNotification(
        'orgStructure.notification.syncSuccess',
        NOTIFICATION_TYPE.SUCCESS,
      )
    } else {
      addNotification(
        response?.message || 'notification.syncError',
        NOTIFICATION_TYPE.ERROR,
      )
      throw new Error(response?.message)
    }
  } catch (error) {
    yield put(actSyncOrgStructureFailed())
    // Call callback action if provided
    if (action.onError) {
      yield action.onError(error)
    }
  }
}

export default function* watchSync() {
  yield takeLatest(MASTER_SYNC_ORG_STRUCTURE, doSync)
}
